import React, { useEffect, useState} from 'react'
import { useForm } from 'react-hook-form';
import {sweetalert} from "../../App";
import UsersAPI from '../../network/UsersAPI';

export default function ForgotPassword() {
    const [loading, setLoading] = useState(false)
    const [email, setEmail ] = useState(null)

    // Form Validations
    const [form, setForm] = useState({})
    const { register, handleSubmit, formState: { errors }, trigger, reset} = useForm({
        mode: "onTouched"
    });
    const [isReset, setReset] = useState(false);
    
    useEffect(() => {
        console.log(' useEffect reset')
        reset(form);
        setReset(true);
    }, [reset, form]); // <= runs when reset state or form state updates

    useEffect(() => {
        console.log(' useEffect isReset')
        isReset && trigger()
    }, [isReset]) // <= runs when trigger state or isReset state updates
    useEffect(() => {
        console.log(' useEffect setForm')
        setForm({
            email: null
        })
    }, []) //<= runs on first load

    const onSubmit = async (data) => {
        try {
            let response = await UsersAPI.sendResetPasswordEmail(email); // this calls our backend route which will actuall 
            if(!response.success){
                return sweetalert.fire({icon:'error',text: response.reason})
            } else {
                sweetalert.fire({ icon: 'success', text: 'Please check your email for instructions.' })
                    .then(() => {
                        window['location'] = '/login' as unknown as Location;
                    })
            }
        }
        catch(e){
            console.error(e);
            return sweetalert.fire({text: e, icon: 'error'});
        }
        setLoading(false);
    }

    const onError = (e) => {
        console.error(e)
    }

    return (
        <div className={"container"}>
            <div className="row justify-content-center mt-5">
                <div className="col-lg-4 col-md-6 col-sm-6">
                    <div className="card shadow">
                        <div className="card-title text-center border-bottom">
                            <img src={"https://storage.googleapis.com/streamline-bucket/FullNoBackground.png"}
                                style={{ width: '200px', margin: '20px' }}
                                className={'nav-logo'} alt={"logo"}
                            />
                        </div>
                        <div className="card-body">

                            <form onSubmit={(e) => handleSubmit(onSubmit,onError)(e).catch((e)=>{
                                console.error(' catch ',e)
                            })}>
                                <div className="mb-4">
                                    <label htmlFor="email" className="form-label">Username/Email</label>
                                    <input type="text" className="form-control" 
                                        id="email" name="email"
                                        {...register("email",{
                                            required:"Username/Email is required",
                                            pattern: {
                                                value: /^[a-zA-Z0-9\D]+@[a-zA-Z0-9]+\.[A-Za-z]+$/,
                                                message: 'Please verify email syntax.'
                                            },
                                        })}
                                        onChange={(e)=>{
                                            setEmail(e.target.value.trim())
                                            setForm({...form, 'email':e.target.value.trim() })
                                        }}
                                        />
                                    {errors.email && <small style={{ color: 'red' }} className={"error"}>{errors.email.message}</small>}
 
                                </div>
                                <div className="mb-4 text-center">
                                    <button type="submit"
                                        className="btn btn-lg bg-immy-blue text-white col-12"
                                        disabled={loading}
                                    >Reset Password</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}